import {useMutation, useQuery} from '@tanstack/react-query';

import {RQ_ADD_DELIVERY_CHARGES, RQ_GET_DELIVERY_CHARGES, RQ_UPDATE_DELIVERY_CHARGES} from './constants';
import {rqCreateRequest} from './rqHttpUtils';

export const RqGetDeliveryCharges= token => {
  return useQuery({
    queryKey: ['rq_get_all_department', token],
    queryFn: async () => {
      if (!token) {throw new Error('Token is required');}
      const response = await rqCreateRequest(RQ_GET_DELIVERY_CHARGES, null, token, null);
      return response || [];
    },
    enabled: Boolean(token),
    refetchOnWindowFocus: false,
    retry: 1,
  });
};

export const RqAddDeliveryCharges = (options = {}) => {
  return useMutation({
    mutationKey: ['rq_register_charges'],
    mutationFn: async ({token, formData}) => {
      return rqCreateRequest(
        RQ_ADD_DELIVERY_CHARGES,
        formData,
        token,
        null,
      );
    },
    ...options,
  });
};

export const RqUpdateliveryCharges = (options = {}) => {
  return useMutation({
    mutationKey: ['rq_update_charges'],
    mutationFn: async ({token, formData, id}) => {
      const url = RQ_UPDATE_DELIVERY_CHARGES.url.replace('<%= id %>', id);
      try {
        const response = await rqCreateRequest(
          {...RQ_UPDATE_DELIVERY_CHARGES, url},
          formData,
          token,
          null,
        );

        return response;
      } catch (error) {
        console.error('Error updating department:', error);
        throw error;
      }
    },
    ...options,
  });
};
